<template>
  <v-dialog v-model="interno" max-width="400">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ titulo }}
      </v-card-title>

      <v-card-text class="pt-4">
        {{ mensagem }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="fechar">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AlertaModal',
  props: {
    value: Boolean,
    titulo: {
      type: String,
      default: 'Atenção',
    },
    mensagem: {
      type: String,
      required: true,
    },
  },
  computed: {
    interno: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    fechar() {
      this.interno = false;
    },
  },
};
</script>
